import { _ } from "../../core/polyglot/polyglot.js";

const knownPeriodTypes = {};

/**
 * Simple model representing a period type.
 *
 * @param {string} id - Unique identifier
 * @param {function():polyglot} getName - Should return a displayable
 *   content describing the period type
 */
class PeriodType {
	constructor({ id, getName }) {
		this._id = id;
		this._getName = getName;
	}

	getId() {
		return this._id;
	}

	getName() {
		return this._getName();
	}

	isCurrentPeriodType() {
		return false;
	}
}

/**
 * Todo: Add JSDoc comment
 */
export function getPeriodTypeFromId(id) {
	return knownPeriodTypes[id];
}

/**
 * The Current period type is a bit special, as its actual value is late-bound.
 * To reflect this specificity, an accessor is exposed to be able to filter.
 */
class CurrentPeriodType extends PeriodType {
	isCurrentPeriodType() {
		return true;
	}
}

export const currentPeriodType = new CurrentPeriodType({
	id: "Current",
	getName: () => _("Current"),
});

export const day = new PeriodType({
	id: "Day",
	getName: () => _("Day"),
});

export const week = new PeriodType({
	id: "Week",
	getName: () => _("Week"),
});

export const month = new PeriodType({
	id: "Month",
	getName: () => _("Month"),
});

export const bimester = new PeriodType({
	id: "Bimester",
	getName: () => _("Bimester"),
});

export const quarter = new PeriodType({
	id: "Quarter",
	getName: () => _("Quarter"),
});

export const halfYear = new PeriodType({
	id: "HalfYear",
	getName: () => _("Half Year"),
});

export const year = new PeriodType({
	id: "Year",
	getName: () => _("Year"),
});

export const yearToDate = new PeriodType({
	id: "YearToDate",
	getName: () => _("Year to Date"),
});

knownPeriodTypes[currentPeriodType.getId()] = currentPeriodType;
knownPeriodTypes[day.getId()] = day;
knownPeriodTypes[week.getId()] = week;
knownPeriodTypes[month.getId()] = month;
knownPeriodTypes[bimester.getId()] = bimester;
knownPeriodTypes[quarter.getId()] = quarter;
knownPeriodTypes[halfYear.getId()] = halfYear;
knownPeriodTypes[year.getId()] = year;
knownPeriodTypes[yearToDate.getId()] = yearToDate;
